// Color styles for each topic type
// Updated to use the colors from the Kanban board columns
export const TOPIC_COLORS = {
  ai_chat: {
    icon: 'text-blue-600',
    bgDefault: 'bg-gray-100',
    bgHover: 'bg-blue-100',
    active: 'bg-blue-500 text-white',
    collapsedIcon: 'text-gray-400',
    collapsedBg: 'bg-gray-50',
    defaultIcon: 'text-gray-400',
  },
  notes: {
    icon: 'text-purple-600',
    bgDefault: 'bg-gray-100',
    bgHover: 'bg-purple-100',
    active: 'bg-purple-500 text-white',
    collapsedIcon: 'text-gray-400',
    collapsedBg: 'bg-gray-50',
    defaultIcon: 'text-gray-400',
  },
  todo: {
    icon: 'text-green-600',
    bgDefault: 'bg-gray-100',
    bgHover: 'bg-green-100',
    active: 'bg-green-500 text-white',
    collapsedIcon: 'text-gray-400',
    collapsedBg: 'bg-gray-50',
    defaultIcon: 'text-gray-400',
  },
  list: {
    icon: 'text-orange-600',
    bgDefault: 'bg-gray-100',
    bgHover: 'bg-orange-100',
    active: 'bg-orange-500 text-white',
    collapsedIcon: 'text-gray-400',
    collapsedBg: 'bg-gray-50',
    defaultIcon: 'text-gray-400',
  },
  moodboard: {
    icon: 'text-pink-600',
    bgDefault: 'bg-gray-100',
    bgHover: 'bg-pink-100',
    active: 'bg-pink-500 text-white',
    collapsedIcon: 'text-gray-400',
    collapsedBg: 'bg-gray-50',
    defaultIcon: 'text-gray-400',
  },
  bookmarks: {
    icon: 'text-yellow-600',
    bgDefault: 'bg-gray-100',
    bgHover: 'bg-yellow-100',
    active: 'bg-yellow-500 text-white',
    collapsedIcon: 'text-gray-400',
    collapsedBg: 'bg-gray-50',
    defaultIcon: 'text-gray-400',
  },
  table: {
    icon: 'text-cyan-600',
    bgDefault: 'bg-gray-100',
    bgHover: 'bg-cyan-100',
    active: 'bg-cyan-500 text-white',
    collapsedIcon: 'text-gray-400',
    collapsedBg: 'bg-gray-50',
    defaultIcon: 'text-gray-400',
  },
  default: {
    icon: 'text-red-600',
    bgDefault: 'bg-gray-100',
    bgHover: 'bg-red-100',
    active: 'bg-red-500 text-white',
    collapsedIcon: 'text-gray-400',
    collapsedBg: 'bg-gray-50',
    defaultIcon: 'text-gray-400',
  }
};